<template>
    <div class="p-fluid flex flex-row align-items-center justify-content-between">
        <h5 class="m-0" style="font-size: 1.25rem">Autorizações de Pagamento</h5>

        <i
            class="pi pi-sync w-auto h-1 icone-hover"
            v-if="$temAcessoView('BORDEROS-06') && $route.name === 'Listagem_Borderos_Aguardando'"
            @click="buscarBorderosRm()"
            v-tooltip.top="'Buscar borderôs no RM'"
            style="color: #3e6ba8; font-size: 18px"
        ></i>

        <i
            class="pi pi-sync w-auto h-1 icone-hover"
            v-if="$temAcessoView('BORDEROS-07') && $route.name === 'Listagem_Borderos_Aprovados'"
            @click="buscarBorderosRm"
            v-tooltip.top="'Liberar borderôs no RM'"
            style="color: #3e6ba8; font-size: 18px"
        ></i>

        <i
            class="pi pi-sync w-auto h-1 icone-hover"
            v-if="$temAcessoView('BORDEROS-08') && $route.name === 'Listagem_Borderos_Reprovados'"
            @click="buscarBorderosRm"
            v-tooltip.top="'Reprovar borderôs no RM'"
            style="color: #3e6ba8; font-size: 18px"
        ></i>
    </div>

    <div class="flex flex-row mb-3 mt-5">
        <SelectButton
            v-model="opcaoStatusSelecionada"
            :allowEmpty="false"
            :options="opcoesStatus"
            optionLabel="descricao"
            optionValue="valor"
            dataKey="valor"
            aria-labelledby="basic"
            class="w-full lg:w-max"
        >
            <template #option="slotProps">
                <p class="lato-regular identificador m-0 p-0 w-full flex flex-row align-items-center justify-content-center">
                    {{ slotProps.option.descricao }}
                </p>
            </template>
        </SelectButton>
    </div>

    <ListagemAguardandoAprovacao
        @atualizarDados="obterBorderos()"
        v-if="opcaoStatusSelecionada === 0"
        :borderos="borderosPorStatus?.borderosAguardandoAprovacao"
    ></ListagemAguardandoAprovacao>
    <ListagemAprovados v-if="opcaoStatusSelecionada === 1" :borderos="borderosPorStatus?.borderosAprovados"></ListagemAprovados>
    <ListagemReprovados v-if="opcaoStatusSelecionada === 2" :borderos="borderosPorStatus?.borderosReprovados"></ListagemReprovados>
</template>

<script>
import BorderoService from './service';
import ListagemAguardandoAprovacao from './ListagemAguardandoAprovacao.vue';
import ListagemAprovados from './ListagemAprovados.vue';
import ListagemReprovados from './ListagemReprovados.vue';

export default {
    components: {
        ListagemAguardandoAprovacao,
        ListagemAprovados,
        ListagemReprovados,
    },

    data() {
        return {
            borderosPorStatus: null,
            opcaoStatusSelecionada: 0,
            opcoesStatus: [
                {
                    valor: 0,
                    descricao: 'Aguardando',
                },
                {
                    valor: 1,
                    descricao: 'Aprovados',
                },
                {
                    valor: 2,
                    descricao: 'Recusados',
                },
            ],
            borderosRotas: ['Listagem_Borderos_Aguardando', 'Listagem_Borderos_Aprovados', 'Listagem_Borderos_Reprovados'],
        };
    },

    methods: {
        obterBorderos() {
            this.$store.dispatch('addRequest');
            BorderoService.obterTodos()
                .then((response) => {
                    this.borderosPorStatus = { ...response.data };
                })
                .finally(() => this.$store.dispatch('removeRequest'));
        },

        buscarBorderosRm() {
            this.$store.dispatch('addRequest');
            BorderoService.buscarBorderosRm().then((response) => {
                if (response?.success) {
                    this.obterBorderos();
                    this.$toast.add({ severity: 'success', summary: 'Sucesso!', detail: 'Borderôs obitidos com sucesso', life: 3000 });
                } else {
                    this.$toast.add({ severity: 'success', summary: 'Error!', detail: response.errors[0], life: 3000 });
                }
                this.$store.dispatch('removeRequest');
            });
        },

        direcionarRota() {
            this.opcaoStatusSelecionada = this.borderosRotas.indexOf(this.$route.name);
        },
    },

    mounted() {
        this.obterBorderos();
        this.direcionarRota();
    },

    watch: {
        opcaoStatusSelecionada(valor) {
            this.$router.push({ name: this.borderosRotas[valor] });
        },
    },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');

.lato-regular {
    font-family: 'Lato', Arial, sans-serif;
    font-weight: 400;
}

.selectbutton-altura-personalizada {
    height: 2.75rem !important;
}

.selectbutton-inativo-cor .p-button {
    background: #e2e2e2;
}

.bordas-btn-esquerda {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
}

.bordas-btn-meio {
    border-radius: 0 !important;
}

.bordas-btn-direita {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
}

.p-button:has(> p.identificador) {
    color: #2c2c2c !important;
    background: #e2e2e2;
    width: 33.3333% !important;
}

.p-button:has(> p.identificador):focus {
    box-shadow: none;
}

.p-highlight:has(> p.identificador) {
    border-color: #3e6ba8 !important;
    background-color: #3e6ba8 !important;
    color: #f3f3f3 !important;
}

.icone-hover:hover {
    cursor: pointer;
}
</style>
